export default __webpack_public_path__ + "static/media/b2.0234f710.jpg";